import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { EuiCallOut, EuiFlexGroup, EuiFlexItem, EuiLoadingContent, EuiPanel, EuiSpacer, EuiText } from '@elastic/eui'

import { RootState } from 'app/rootReducer'

import { fetchAd } from '../adSlice'

const POLLING_INTERVAL_MS = 30000

const View: React.FC = () => {
  const { adId } = useParams<{ adId: string }>()
  const dispatch = useDispatch()
  const { ad } = useSelector((state: RootState) => state)
  const { currentAccount } = useSelector((state: RootState) => state.app)
  const pollingRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const uploadedDetails = ad.ad?.tvCommercialUploadedDetails
  const templateDetails = ad.ad?.tvCommercialDetails

  const isUploadedProcessing = uploadedDetails?.shouldHaveWebOptimizedUrl === true && !uploadedDetails?.webOptimizedUrl
  const isTemplateProcessing = !!templateDetails && !templateDetails.finalUrl && !templateDetails.previewUrl
  const isProcessing = isUploadedProcessing || isTemplateProcessing

  const videoSrc = templateDetails?.finalUrl ?? templateDetails?.previewUrl ?? uploadedDetails?.webOptimizedUrl ?? uploadedDetails?.uploadedUrl

  useEffect(() => {
    if (isProcessing && currentAccount && adId) {
      pollingRef.current = setInterval(() => {
        dispatch(fetchAd(currentAccount.id, adId))
      }, POLLING_INTERVAL_MS)
    }

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current)
        pollingRef.current = null
      }
    }
  }, [isProcessing, currentAccount, adId, dispatch])

  return (
    <EuiPanel grow={false}>
      <EuiText>
        <h4>TV Commercial Details</h4>
      </EuiText>
      <EuiSpacer />
      {isProcessing && (
        <React.Fragment>
          <EuiCallOut title='This TV Commercial is being processed for streaming.' size='s' iconType='clock' color='primary'>
            <p>Preview typically available in a few minutes.</p>
          </EuiCallOut>
          <EuiSpacer />
        </React.Fragment>
      )}
      <EuiFlexGroup>
        <EuiFlexItem grow={true} />
        <EuiFlexItem>
          {!ad || !ad.ad ? (
            <EuiLoadingContent />
          ) : videoSrc ? (
            isProcessing ? (
              <div style={{ position: 'relative', width: '100%' }}>
                <video preload='metadata' src={videoSrc} style={{ width: '100%', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <EuiText color='ghost' size='m'><h3>Processing...</h3></EuiText>
                </div>
              </div>
            ) : (
              <video controls preload='metadata' src={videoSrc} style={{ width: '100%' }} />
            )
          ) : isProcessing ? (
            <div style={{ width: '100%', aspectRatio: '16 / 9', backgroundColor: 'rgba(0, 0, 0, 0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <EuiText color='ghost' size='m'><h3>Processing...</h3></EuiText>
            </div>
          ) : null}
        </EuiFlexItem>
        <EuiFlexItem grow={true} />
      </EuiFlexGroup>
    </EuiPanel>
  )
}

export default View
